<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-back-button slot="start"></ion-back-button>
    <ion-title>{{plan?.name}} Plan</ion-title>
    <super-button slot="end" size="small" sxRadius="medium" sxMargin="0 medium" confirmationTitle="Delete Plan?" type="clear" color="danger"
                  [action]="deletePlan">Delete
    </super-button>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div sxRow sxGap="10px" *ngIf="plan" sxPadding="medium">
    <super-input sxWidth="fill" label="Plan Name" [(value)]="plan.name"></super-input>
    <super-input sxWidth="fill" label="Status" [options]="planStatusOptions" type="dropdown"
                 [(value)]="plan.status"></super-input>
    <super-input sxWidth="fill" label="Type" [options]="planTypeOptions" type="dropdown"
                 [(value)]="plan.type"></super-input>

    <super-input sxWidth="fill" label="Visibility" [options]="planVisibilityOptions" type="dropdown"
                 [(value)]="plan.visibility"></super-input>

    <super-input sxWidth="fill" label="Plan User" [options]="planUserOptions" type="dropdown"
                 [(value)]="plan.planUser"></super-input>
  </div>

  <div sxPadding="medium" sxBorderWidth="5px 0" sxBorderColor="one" sxCol sxGap="5px">

    <div sxRow sxDistribution="spaceBetween" sxPadding="medium" sxAlign="start">
      <h3 sxMargin="0">Pricing Model</h3>
      <super-button size="small" iconStart="add-outline" (click)="onAddPricingModelClicked()">Add</super-button>
    </div>
    <div sxRow sxGap="10px">
      <div *ngFor="let pricingModel of plan.planPricingModels;let i = index"
           sxBackground="light" sxRadius="medium" sxPadding="medium" sxWidth="300px"
           class="pricing-cards" sxGap="10px" sxCol
      >

        <div sxRow>
          <div sxWidth="50px"></div>
          <input sxTextWeight="bold" sxTextSize="medium" placeholder="Title" [(ngModel)]="pricingModel.name">
          <super-button (click)="onDeletePricingModel(i)" sxWidth="50px" height="40px" type="clear" padding="0" color="danger">
            <ion-icon sxTextSize="large" name="trash"></ion-icon>
          </super-button>
        </div>


        <div sxRow>
          <div sxCol sxAlign="center">
            <p sxTextSize="small" sxColor="two">Days</p>
            <input type="number" [(ngModel)]="pricingModel.validityDays">
          </div>
          <div sxCol sxAlign="center">
            <p sxTextSize="small" sxColor="two">Price</p>
            <input type="number" [(ngModel)]="pricingModel.amount">
          </div>
          <div sxCol sxAlign="center">
            <p sxTextSize="small" sxColor="two">Discount</p>
            <input type="number" [(ngModel)]="pricingModel.discountAmount">
          </div>
        </div>

        <h2 sxTextAlign="center" sxTextWeight="bold">₹{{pricingModel.amount - pricingModel.discountAmount}}</h2>

        <input [(ngModel)]="pricingModel.discountHighlightLine" placeholder="Discount Remark">

        <div sxRow sxBorderColor="one" sxBorderWidth="1px 0 0" sxPadding="10px 0">
          <div sxRow>
            <div sxCol sxAlign="center">
              <p sxTextSize="small" sxColor="two">Free Franchise</p>
              <input [(ngModel)]="pricingModel.freeMembers">
            </div>
            <div sxCol sxAlign="center">
              <p sxTextSize="small" sxColor="two">Price/Franchise</p>
              <input [(ngModel)]="pricingModel.amountPerMember">
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>

  <div sxPadding="medium medium 10% medium" sxCol sxGap="10px">
    <div sxRow sxDistribution="spaceBetween" sxAlign="center" sxPadding="medium">
      <h3 sxMargin="0 10px 10px">Features</h3>
      <super-button size="small" iconStart="add-outline" (click)="onAddFeatureClicked()">Add</super-button>
    </div>
    <div sxRadius="medium"
         sxBackground="light" sxPadding="medium"
         sxRow sxGap="10px" sxAlign="center" sxDistribution="spaceBetween"
         *ngFor="let planFeatureQuota of plan.planFeatureQuota">
      <p>{{getFeatureByKeyName(planFeatureQuota.featureKeyName)?.name}}</p>
      <div sxRow>
        <p>Default Quota: {{getFeatureByKeyName(planFeatureQuota.featureId)?.defaultQuota}}</p>
      </div>

      <ion-select sxWidth="100px" label="Period" [(ngModel)]="planFeatureQuota.period">
        <ion-select-option value="flat">Flat</ion-select-option>
        <ion-select-option value="monthly">Monthly</ion-select-option>
        <ion-select-option value="yearly">Yearly</ion-select-option>
      </ion-select>

      <div sxRow sxGap="10px" sxAlign="center" sxDistribution="spaceBetween">
        <p>Plan Quota</p>
        <input [(ngModel)]="planFeatureQuota.quota" type="number" sxBackground='light'>
        <super-button (click)="onDeleteFeature(planFeatureQuota)" padding="0" height="fit" type="clear" color="danger">
          <ion-icon name="trash"></ion-icon>
        </super-button>
      </div>
    </div>
  </div>

  <page-action>
    <div sxRow sxDistribution="spaceBetween" sxAlign="center" sxWidth="full">
      <super-button [action]="updatePlan" >Update</super-button>
    </div>
  </page-action>

</ion-content>
